export const formatSingaporeNumber = (number) => {
    if (number === null || number === undefined || number === 'N/A') return 'N/A';

    // Singapore uses en-SG locale which formats numbers with commas
    return new Intl.NumberFormat('en-SG').format(number);
};